/*
 * Copyright 2024 The Kokabo Authors. All rights reserved.
 * Use of this source code is governed by a BSD-style
 * license that can be found in the LICENSE file.
 */

/**
 * Process-local cache to avoid repeating hub discovery and E2EE key exchange.
 */
export class HubsInfoCache {
    /**
     * @type {Object.<string, HubInfo>}
     * @private
     */
    static _cache = {};

    static get(hubName, host) {
        const key = `${hubName}-${host}`;
        return HubsInfoCache._cache[key]
    }


    /**
     * Cache is authoritative for subsequent `HubInfo.get(...)` calls to prevent redundant key exchanges.
     * @param {HubInfo} hub
     * @return  {Promise<HubInfo>}
     */
    static cache(hub) {
        if (!hub) {
            return Promise.reject(new Error("[Hubs.cache] void hub can't be cached"));
        }
        const key = `${hub.name}-${hub.host}`;
        HubsInfoCache._cache[key] = hub
        return Promise.resolve(hub);
    }


    static forget(hub) {
        if (!hub) {
            throw new Error("[Hubs.forget] void hub can't be forgotten");
        }
        const key = `${hub.name}-${hub.host}`;
        delete HubsInfoCache._cache[key];
    }
}